<template>
  <div
    class="modal modal-sheet position-static d-block bg-body-secondary p-4 py-md-5"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content rounded-4 shadow">
        <div class="modal-header border-bottom-0">
          <slot name="header">
            <!-- 默认标题插槽 -->
            <h1 class="modal-title fs-5">Default Modal Title</h1>
          </slot>
          <button
            type="button"
            class="btn-close"
            @click="closeModal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body py-0">
          <slot>
            <!-- 默认内容插槽 -->
            <p>Default modal content...</p>
          </slot>
        </div>
        <div
          class="modal-footer flex-column align-items-stretch w-100 gap-2 pb-3 border-top-0"
        >
          <slot name="footer">
            <!-- 默认底部插槽 -->
            <button type="button" class="btn btn-lg btn-primary">
              Save changes
            </button>
            <button type="button" class="btn btn-lg btn-secondary">
              Save changes
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseModal",
  methods: {
    closeModal() {
      // 触发事件通知父组件关闭模态框
      this.$emit("close");
    },
  },
};
</script>

<style>
/* 移除背景色 */
.modal.modal-sheet {
  display: flex !important; /* 启用 flexbox */
  align-items: center !important; /* 垂直居中 */
  justify-content: center !important; /* 水平居中 */
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
}

.modal-dialog {
  margin: 20% !important; /* 移除默认的 margin */
}

.modal-content {
  padding: 20px !important;
  width: 450px !important; /* 设置模态框的宽度 */
  max-width: 100% !important; /* 确保宽度不会超过屏幕宽度 */
  /* 可以在这里添加更多样式，例如 padding 或 border */
}
/* 手机屏幕 */
@media (max-width: 576px) {
  .modal-content {
    width: 90% !important; /* 手机屏幕上模态框宽度为 90% */
  }
}
</style>
